import { render, staticRenderFns } from "./mrc_ess_showClientType.vue?vue&type=template&id=644a2294&scoped=true&"
import script from "./mrc_ess_showClientType.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_showClientType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a2294",
  null
  
)

export default component.exports